import { API, get, post } from "../../config";

export const getUserDetail = async (id) => {
  try {
    const { data } = await get(`${API.GET_USER}/` + id);
    return data.data;
  } catch (e) {
    return null;
  }
};

export const refreshBankTransactions = async (
  projectId,
  trust_type,
  startDate,
  endDate
) => {
  try {
    const { data } = await post(`${API.REFRESH_BANK_TRANSACTION}`, {
      trust_id: projectId,
      start_date: startDate,
      end_date: endDate,
    });
    return data;
  } catch (error) {
    return null;
  }
};

export const getNextPageData = async (
  page,
  projectId,
  trust_type,
  sortField,
  sortOrder
) => {
  try {
    const { data } = await get(
      `${
        API.BANK_RECONCILIATION_LIST
      }?trust_id=${projectId}&sort_column=${
        sortField ? sortField : ""
      }&sort_order=${sortOrder ? sortOrder : ""}&limit=10&page=${page}`
    );
    return data?.data;
  } catch (e) {
    throw e;
  }
};

export const getUnderReviewedNextPageData = async (
  page,
  projectId,
  trust_type,
  sortField,
  sortOrder
) => {
  try {
    const { data } = await get(
      `${
        API.BANK_RECONCILIATION_LIST
      }?trust_id=${projectId}&sort_column=${
        sortField ? sortField : ""
      }&sort_order=${sortOrder ? sortOrder : ""}&limit=10&page=${page}`
    );
    return data?.data;
  } catch (e) {
    throw e;
  }
};
